import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ClaimApprovalDelegationPeriodContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class ClaimApprovalDelegationPeriodService extends BaseApiTemplateService<ClaimApprovalDelegationPeriodContainerModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX +
    "approval-delegation-periods/backoffice-ep";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX +
      "approval-delegation-periods/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX +
      "approval-delegation-periods/backoffice-ep";
    this.httpClient = http;
  }
}
